import PropTypes from 'prop-types';

import companiesStrings from 'modules/companies/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './CompaniesFilter.style';

const CompaniesFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={companiesStrings.companiesFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);

CompaniesFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default CompaniesFilter;
